import { Component, OnInit,Inject, ViewChild, ChangeDetectorRef, AfterViewInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { DatePipe } from '@angular/common';
import { MatTabGroup } from '@angular/material/tabs';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import * as XLSX from 'xlsx';
import Swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ProjectsPromotionsAddComponent } from '../../shared/dialogs/projects-promotions-add/projects-promotions-add.component';
import { UsersService } from 'src/app/services/users.service';
import { ProjectsPromotionsLogsComponent } from '../../shared/dialogs/projects-promotions-logs/projects-promotions-logs.component';
import { PromotionsConfigurationComponent } from '../../shared/dialogs/promotions-configuration/promotions-configuration.component';

@Component({
  selector: 'app-project-promotions',
  templateUrl: './project-promotions.component.html',
  styleUrls: ['./project-promotions.component.scss'],
  providers: [DatePipe]
})
export class ProjectPromotions implements OnInit, AfterViewInit {

  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild('solicitudesPaginator') solicitudesPaginator!: MatPaginator;
  @ViewChild('tabGroup') tabGroup!: MatTabGroup;


  isLoading = false;
  groupForm!: FormGroup;
  id_camp : number = 0;
  promotionFile : Array<any>= [];
  dspromotionFile: any = [];
  displayedColumns: string[] = [];
  allColumns: string[] = [];
  workbook: any;
  fileName: string = '';
  originalPromotionFile: Array<any> = [];
  hasChanges: boolean = false;
  file_id : number = 0;
 
  editingRow: any | null = null;
  originalRowData: any = null;
  createdRows = new Set<any>();
  editedRows = new Map<number, { originalIndex: number, codigo: string, changes: any, responsable_promocion: any }>(); // Key: originalIndex
  deletedRows = new Map<number, { originalIndex: number, codigo: string, data : any }>(); // Key: originalIndex
  codigosList: string = '';
  bodyForm : FormData = new FormData(); 
  folder : string = '';
  statusSelected: number = 0;
  selectedChanges = new Map<number, Set<string>>();
  solicitudesFilterValue: string = '';
  selectedSolicitudes = new Set<number>();
  pendingRequestCodes = new Set<string>();
  pendingRequestIndexes = new Set<number>();

  countPromociones: number = 0;
  countPendientes: number = 0;
  countAprobadas: number = 0;
  countRechazadas: number = 0;
  columnsProm: string[] = [];
  totalColumsProm : string[] = [];
  originalData : any = [];
  sumResponsable : number = 0;
  sumSinResponsable : number = 0;
  isDownloadingHistory: boolean = false;
  
  constructor(
       private projectsS: ProjectsService,
       private main: MainService,
       private datePipe: DatePipe,
       private cdr: ChangeDetectorRef,
       private _params: ActivatedRoute,
       private _router: Router,
        private matDialog: MatDialog,
        private userService: UsersService
       ) { 
      
      this._params.params.subscribe(params => {
        if(params.id_camp){
           this.id_camp = params.id_camp;
           this.folder = params.folder;
        }else{
          this._router.navigateByUrl('/admin/dashboard');
        } 
      });

      this.preloadFormData();
      console.log(this.folder);
 }

  ngOnInit(): void {
    this.getPromoFile()
  }

  ngAfterViewInit() {
    this.tabGroup.selectedIndex = 0;

  }

  onSubmit(){
    console.log('test')
  }

  preloadFormData(){
    this.bodyForm.append('id_proj', this.id_camp.toString() as string); 
    this.bodyForm.append('folder', this.folder as string);      
  }

  goBackProjects(){
    this._router.navigateByUrl('/admin/projects/' + this.id_camp);
  }

  hasPermissions(key : string, buho : boolean|any, client : boolean|any):  boolean {
    return this.userService.hasPermissions(key, buho, client);
  }

  config = [];
  editableColumns = new Set<string>();

  getPromoFile(){
    this.main.ShowLoading();
    this.projectsS.getPromotionDownload(this.id_camp).subscribe(async (res: any) => {
   
        if (res.message === "Success") {
          this.fileName = res.fileName;
          this.file_id = res.file_id;
          this.config = res.config;
        
          this.bodyForm.append('id_file', this.file_id.toString() as string); 
          
          const base64String = res.data;
          console.log("fileid", this.file_id);
          
          this.workbook = XLSX.read(base64String, { type: 'base64', cellDates: true });
          const sheetName = this.workbook.SheetNames[0];
          const worksheet = this.workbook.Sheets[sheetName];
          
          const data: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });

          //Agregar responsable si no existe en el excel
          const headersFromSheet = (XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] as string[])?.map(h => h.trim()) || [];
          const hasResponsableColumn = headersFromSheet.includes('RESPONSABLE_PROMOCION');

          const newData = data.map(row => {
            const newRow = { ...row };
            if (!hasResponsableColumn || newRow.RESPONSABLE_PROMOCION === undefined || newRow.RESPONSABLE_PROMOCION === null) {
              newRow.RESPONSABLE_PROMOCION = '-';
            }
            return newRow;
          });

          const cleanedData = newData.map(row => {
            const newRow: any = {};
            for (const key in row) {
              if (Object.prototype.hasOwnProperty.call(row, key)) {
                newRow[key.trim()] = row[key];
              }
            }
            return newRow;
          });

          cleanedData.forEach(row => {
            for (const key in row) {
              if (row[key] instanceof Date) {
                row[key] = this.datePipe.transform(row[key], 'yyyy-MM-dd');
              }
            }
          });
          this.originalPromotionFile = JSON.parse(JSON.stringify(cleanedData)); 
          this.countPromociones = this.originalPromotionFile.length;

          console.log("promo data", cleanedData);

          this.promotionFile = cleanedData;

          this.promotionFile.forEach((row, index) => {
            row.status = 'normal';
            row.originalIndex = index;
          });
         
          this.hasChanges = false;
          this.dspromotionFile = new MatTableDataSource(this.promotionFile);
          this.dspromotionFile.paginator = this.paginator;
          this.dspromotionFile.sort = this.sort;

          this.originalData = JSON.parse(JSON.stringify(this.dspromotionFile.data));

          if (this.promotionFile && this.promotionFile.length > 0) {
       
            const allUniqueKeys = new Set<string>();
            this.promotionFile.forEach(row => {
              Object.keys(row).forEach(key => {
                const trimmedKey = key.trim();
               
                if (trimmedKey !== '' && trimmedKey !== 'status' && trimmedKey !== 'originalIndex') {
                  allUniqueKeys.add(trimmedKey);
                }
              });
            });
            
            this.displayedColumns = Array.from(allUniqueKeys);
           
            if (this.displayedColumns.includes('CODIGO PRINCIPAL')) {
              this.displayedColumns = this.displayedColumns.filter(col => col !== 'CODIGO PRINCIPAL');
              this.displayedColumns.unshift('CODIGO PRINCIPAL');
            }
        
            this.columnsProm = Array.from(allUniqueKeys).filter(key => key.toUpperCase() !== 'CODIGO PRINCIPAL');
            this.allColumns = [...this.displayedColumns, 'acciones'];
            this.editableColumns.clear();
            if (this.hasPermissions('super_promo', null, true)) {
              this.displayedColumns.forEach(col => this.editableColumns.add(col));
            } else {
              if (this.config.length === 0) { 
                this.displayedColumns.forEach(col => this.editableColumns.add(col));
              } else if (this.config.length === 1 && this.config[0] === '_empty_') {
               
              } else {
                this.config.forEach(col => this.editableColumns.add(col));
              }
            }
            console.log("Columnas Editables:", this.editableColumns);

          }

        this.editingRow = null;
        this.editedRows.clear();
        this.createdRows.clear();
        this.deletedRows.clear();
        this.sumResponsable = 0;
        this.sumSinResponsable = 0;

        this.getSolicitudes();
     
        }
      
      this.main.HideLoading();
    }, (err:any) => {
      this.main.HideLoading();
      console.error(err);
      Swal.fire('Error', 'No se pudo cargar el archivo de promociones.', 'error');
    });
  } 

  listSolicitudes : any;
  lisDataSolicitudes : any;
  formedSolicitudes : any;
  dsSolicitudes: any = [];
  solicitudesColumns: string[] = [];


  getSolicitudes(){
    this.main.ShowLoading();
    this.projectsS.getSolicitudes(this.id_camp, this.file_id, false ).subscribe(async (res: any) => {
      this.main.HideLoading();
      if (res.message === "Success") { 
          this.listSolicitudes = res.solicitudes;
          this.lisDataSolicitudes = res.editados;
          const perm_promo = this.hasPermissions('super_promo',null,true)

          this.formedSolicitudes = this.listSolicitudes.map((solicitud: any) => {
    
            const data_solicitud = this.lisDataSolicitudes.filter(
              (data: any) => data.id_solicitud === solicitud.id
            );
            

            let has_accepted_change = 0;
            if (solicitud.tipo === 1 && data_solicitud) {
              if (data_solicitud.some((change: any) => change.estatus === 1)) {
                has_accepted_change = 1;
              }
            }


            const solicitudConDetalle = { ...solicitud, data_solicitud };
            const originalIndex = this.getSolicitudOriginalIndex(solicitudConDetalle);
            const original_info = originalIndex !== null
              ? this.originalPromotionFile[originalIndex]
              : this.originalPromotionFile.find(
                  (originalRow: any) => originalRow['CODIGO PRINCIPAL'] === solicitud.codigo
                );


            return {
              ...solicitudConDetalle,
              originalIndex,
              original_info,
              has_accepted_change
            };
            
          });

          const existingCodes = new Set(this.originalPromotionFile.map(p => p['CODIGO PRINCIPAL']));

          const codigosEliminadosAprobados = this.formedSolicitudes
            .filter((s: any) => s.tipo === 3 && s.status === 2)
            .map((s: any) => s.codigo);

          // Filtrar solicitudes PENDIENTES (status 1) cuyo código ya no existe en el archivo principal.
          // Las aprobadas/rechazadas se conservan para mantener el historial.
          // Se ignora si es una solicitud de "agregar" (tipo 2) que está pendiente, ya que es normal que su código no exista aún.
          this.formedSolicitudes = this.formedSolicitudes.filter((s: any) => {
            const codeExists = existingCodes.has(s.codigo);
            // Mantener si: el código existe, O no está pendiente, O es una solicitud de agregar pendiente.
            return codeExists || s.status !== 1 || (s.tipo === 2 && s.status === 1);
          });

          if (codigosEliminadosAprobados.length > 0) { // Adicionalmente, filtrar las pendientes de eliminar si ya se aprobó.
            this.formedSolicitudes = this.formedSolicitudes.filter((s: any) => {
              return s.status !== 1 || !codigosEliminadosAprobados.includes(s.codigo);
            });
          }

          this.pendingRequestCodes = new Set(
            this.formedSolicitudes
              .filter((s: any) => s.status === 1 && this.getSolicitudOriginalIndex(s) === null)
              .map((s: any) => s.codigo)
          );
          this.pendingRequestIndexes = new Set(
            this.formedSolicitudes
              .filter((s: any) => s.status === 1)
              .map((s: any) => this.getSolicitudOriginalIndex(s))
              .filter((index: number | null): index is number => index !== null)
          );

          console.log("Solicitudes Formateadas:", this.formedSolicitudes);

          if(this.userService.getUser().id_rol == 1){
            this.formedSolicitudes = this.formedSolicitudes
          }
          else if(perm_promo){
            this.formedSolicitudes = this.formedSolicitudes.filter((item:any) => {
              return (item.original_info?.RESPONSABLE_PROMOCION === 'ABIERTA' || item.original_info?.RESPONSABLE_PROMOCION === '-') || (item.original_info?.RESPONSABLE_PROMOCION === this.userService.getUser().email) || item.id_usuario === this.userService.getUser().id;
            });
          }
          else{
            this.formedSolicitudes = this.formedSolicitudes.filter(
              (item:any) => item.id_usuario === this.userService.getUser().id
            );
          }

          this.countPendientes = this.formedSolicitudes.filter((s: any) => s.status === 1).length;
          this.countAprobadas = this.formedSolicitudes.filter((s: any) => s.status === 2).length;
          this.countRechazadas = this.formedSolicitudes.filter((s: any) => s.status === 3).length;

          this.dsSolicitudes = new MatTableDataSource(this.formedSolicitudes);
          this.dsSolicitudes.paginator = this.solicitudesPaginator;

          
          this.dsSolicitudes.filterPredicate = (data: any, filter: string) => {
            const statusMatch = this.statusSelected === 0 || data.status === this.statusSelected;
            if (!statusMatch) {
              return false;
            }

            if (!this.solicitudesFilterValue) {
              return true;
            }

            const searchStr = Object.values(data).join(' ').toLowerCase() + 
                              Object.values(data.extra_data || {}).join(' ').toLowerCase() +
                              Object.values(data.original_info || {}).join(' ').toLowerCase();

            return searchStr.includes(this.solicitudesFilterValue);
          };

          if (this.formedSolicitudes && this.formedSolicitudes.length > 0) {
           
            this.solicitudesColumns = ['nombre_usuario', ...this.displayedColumns, 'solicitud_acciones'];
          }

          if (!this.solicitudesColumns.includes('solicitud_select')) {
            this.solicitudesColumns.unshift('solicitud_select');
          }

          if (this.statusSelected > 0) {
            this.applySolicitudesFilter();
          }

      }});
  }



  toggleSolicitudSelection(solicitud: any) {
    const isSelected = this.selectedSolicitudes.has(solicitud.id);
    if (isSelected) {
        this.selectedSolicitudes.delete(solicitud.id);
        if (solicitud.tipo === 1) {
            this.selectedChanges.delete(solicitud.id);
        }
    } else {
        this.selectedSolicitudes.add(solicitud.id);
        if (solicitud.tipo === 1 && solicitud.data_solicitud) {
            const pendingChanges = solicitud.data_solicitud
                .filter((change: any) => change.estatus === 0)
                .map((change: any) => change.atributo);
            if (pendingChanges.length > 0) {
                this.selectedChanges.set(solicitud.id, new Set<string>(pendingChanges));
            }
        }
    }
  }

  isSolicitudSelected(solicitud: any): boolean {
    return this.selectedSolicitudes.has(solicitud.id);
  }

  toggleSelectAllSolicitudes() {

    if (this.isAllSolicitudesSelected()) {
        this.selectedSolicitudes.clear();
        this.selectedChanges.clear();
    } else {
        this.dsSolicitudes.data.forEach((solicitud: any) => {
            if (!this.selectedSolicitudes.has(solicitud.id)) {
                this.toggleSolicitudSelection(solicitud);
            }
        });
    }
  }

  isAllSolicitudesSelected(): boolean {
    if (!this.dsSolicitudes.data || this.dsSolicitudes.data.length === 0) return false;
    return this.dsSolicitudes.data.every((solicitud: any) => this.selectedSolicitudes.has(solicitud.id));
  }

  // --- Lógica de selección de cambios individuales ---

  toggleChangeSelection(solicitud: any, change: any) {
    if (!this.selectedChanges.has(solicitud.id)) {
      this.selectedChanges.set(solicitud.id, new Set<string>());
    }

    const selectedSet = this.selectedChanges.get(solicitud.id)!;
    if (selectedSet.has(change.atributo)) {
      selectedSet.delete(change.atributo);
    } else {
      selectedSet.add(change.atributo);
    }

    if (selectedSet.size > 0) {
      this.selectedSolicitudes.add(solicitud.id);
    } else {

      this.selectedChanges.delete(solicitud.id);
      this.selectedSolicitudes.delete(solicitud.id);
    }
  }

  isChangeSelected(solicitud: any, change: any): boolean {
    if (!this.selectedChanges.has(solicitud.id)) {
      return false;
    }
    return this.selectedChanges.get(solicitud.id)!.has(change.atributo);
  }

  hasPendingRequest(row: any): boolean {
    const codigo = row['CODIGO PRINCIPAL'];
    return this.pendingRequestIndexes.has(row.originalIndex) || this.pendingRequestCodes.has(codigo);
  }

  private getSolicitudOriginalIndex(solicitud: any): number | null {
    const extraData = solicitud?.extra_data;
    const detailWithIndex = solicitud?.data_solicitud?.find(
      (detail: any) => detail?.fila !== null && detail?.fila !== undefined
    );
    const rawIndex = solicitud?.originalIndex
      ?? solicitud?.original_index
      ?? (typeof extraData === 'object' ? extraData?.originalIndex ?? extraData?.original_index : extraData)
      ?? detailWithIndex?.fila;
    if (rawIndex === null || rawIndex === undefined || rawIndex === '') return null;

    const originalIndex = Number(rawIndex);
    return Number.isInteger(originalIndex) && originalIndex >= 0 ? originalIndex : null;
  }

  private findSolicitudRowIndex(data: any[], solicitud: any): number {
    const originalIndex = this.getSolicitudOriginalIndex(solicitud);
    if (originalIndex !== null && originalIndex < data.length) return originalIndex;

    // Compatibilidad con solicitudes antiguas que no guardaron originalIndex.
    return data.findIndex((row: any) => row['CODIGO PRINCIPAL'] === solicitud.codigo);
  }


  async acceptRow(solicitud: any) {
    console.log("--- ACEPTAR CAMBIOS SELECCIONADOS ---");
    let updatedData = JSON.parse(JSON.stringify(this.originalPromotionFile));
    
    const creations: any[] = [];
    const edits: any[] = [];
    const deletions: any[] = [];

    switch (solicitud.tipo) {
      case 1: // Editar
   
        const selectedAttributes = this.selectedChanges.get(solicitud.id);
        if (!selectedAttributes || selectedAttributes.size === 0) {
          console.log("No hay cambios seleccionados para aceptar en la solicitud de edición:", solicitud.id);
           Swal.fire('Alerta', 'No hay cambios seleccionados para aceptar en la solicitud de edición.', 'warning');
          return;
        }
        const changesToProcess = solicitud.data_solicitud.filter((change: any) => selectedAttributes.has(change.atributo));

        const totalPendingChanges = solicitud.data_solicitud.filter((c: any) => c.estatus === 0).length;
        const finalizada = changesToProcess.length === totalPendingChanges ? 1 : 0;
        
        // Aplicar cambios al excel
        const rowIndex = this.findSolicitudRowIndex(updatedData, solicitud);
        if (rowIndex !== -1) {
          changesToProcess.forEach((change: any) => {
            updatedData[rowIndex][change.atributo] = change.valor_nuevo;
          });
        }

        edits.push({
          id_solicitud: solicitud.id,
          codigo: solicitud.codigo,
          originalIndex: this.getSolicitudOriginalIndex(solicitud),
          data: changesToProcess, 
          tipo : solicitud.tipo,
          finalizada: finalizada
        });
        break;
      case 2: // Agregar
        // Aplicar cambios al excel
        updatedData.push(solicitud.extra_data);

        creations.push({
          codigo: solicitud.codigo,
          tipo: solicitud.tipo,
          id_solicitud : solicitud.id
        });
        break;
      case 3: // Eliminar
        // Aplicar cambios al excel
        const rowIndexToDelete = this.findSolicitudRowIndex(updatedData, solicitud);
        if (rowIndexToDelete !== -1) updatedData.splice(rowIndexToDelete, 1);

        deletions.push({
          codigo: solicitud.codigo,
          originalIndex: this.getSolicitudOriginalIndex(solicitud),
          id_solicitud: solicitud.id,
          tipo: solicitud.tipo
        });
        break;
    }

    const excelBlob = this.generateExcelBlob(updatedData);
    const payload = { creations, edits, deletions };
    const finalBody = new FormData();
    finalBody.append('id_proj', this.id_camp.toString() as string); 
    finalBody.append('folder', this.folder as string);  
    finalBody.append('id_file', this.file_id.toString() as string)
    finalBody.append('payload', JSON.stringify(payload));
    finalBody.append('blob', excelBlob, `promociones_actualizadas.xlsx`);

    console.log("Solicitud (ID:", solicitud.id, ") Body a Aceptar (FormData):", finalBody);
    
    const result = await Swal.fire({
      title: '¿Aceptar solicitud?',
      text: "Se efectuarán las solicitudes de edición.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar'
    });
   if (result.isConfirmed) {
      this.main.ShowLoading();
        this.projectsS.acceptSoliPromociones(finalBody).subscribe({
        next: (x: any) => {
          this.main.HideLoading();
          if (x.message == "Success") {
                       Swal.fire({
                         icon: 'success',
                         title: 'Promociones editadas',
                         text: 'Promociones editadas exitosamente'          
                       }).then(() => {            
                         this.selectedSolicitudes.clear();
                         this.selectedChanges.clear();
                         this.getPromoFile();
                       });  
          } else {
            Swal.fire('Error', 'Ocurrió un error al editar el archivo.', 'error');
          }
        },
        error: (err: any) => {
          this.main.HideLoading();
          console.error(err);
          Swal.fire('Error', 'Ocurrió un error al editar el archivo, por favor vuelve a intentarlo.', 'error');
        }
      });
    }


  }

  private generateExcelBlob(data: any[]): Blob {
    const worksheet = XLSX.utils.json_to_sheet(data);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Promociones');
    
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
    
    return blob;
  }

  async rejectRow(solicitud: any) {
    console.log("--- RECHAZAR CAMBIOS SELECCIONADOS ---");
    const creations: any[] = [];
    const edits: any[] = [];
    const deletions: any[] = [];
    let hasActions = false;

    switch (solicitud.tipo) {
      case 1: // Editar
        const selectedAttributes = this.selectedChanges.get(solicitud.id);
        if (!selectedAttributes || selectedAttributes.size === 0) {
          console.log("No hay cambios seleccionados para rechazar en la solicitud de edición:", solicitud.id);
          return;
        }
        const changesToReject = solicitud.data_solicitud.filter((change: any) => selectedAttributes.has(change.atributo));
        
        const totalPendingChanges = solicitud.data_solicitud.filter((c: any) => c.estatus === 0).length;
        const finalizada = changesToReject.length === totalPendingChanges ? 1 : 0;

        edits.push({
          id_solicitud: solicitud.id,
          codigo: solicitud.codigo,
          data: changesToReject,
          tipo :solicitud.tipo,
          finalizada: finalizada,
          has_accepted_change: solicitud.has_accepted_change
        });
        hasActions = true;
        break;
     
      case 2: // Agregar
      case 3: // Eliminar
        const payloadItem = {
          id_solicitud: solicitud.id,
          codigo: solicitud.codigo,
          tipo: solicitud.tipo
        };
        solicitud.tipo === 2 ? creations.push(payloadItem) : deletions.push(payloadItem);
        hasActions = true;
        break;
    }

    if (!hasActions) {
      console.log("No se ha realizado ninguna acción de rechazo.");
      return;
    }

    const payload = { creations, edits, deletions };    
    const finalBody = {
      id_proj: this.id_camp,
      folder: this.folder,
      payload: payload,
      id_file : this.file_id
    };

    console.log("Solicitud (ID:", solicitud.id, ") Body a Rechazar (JSON):", finalBody);
    const result = await Swal.fire({
      title: '¿Denegar solicitud?',
      text: "Se denegarán las solicitudes de edición.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar'
    });
   if (result.isConfirmed) {

     this.main.ShowLoading();
      this.projectsS.rejectSoliPromociones(finalBody).subscribe(async (res: any) => {
        this.main.HideLoading();
        if (res.message === "Success") {
                       Swal.fire({
                         icon: 'success',
                         title: 'Proceso completado',
                         text: 'Proceso efectuado exitosamente'          
                       }).then(() => {            
                         this.selectedSolicitudes.clear();
                         this.selectedChanges.clear();
                         this.getPromoFile(); 
                       }); 

        }else{
          Swal.fire('Error', 'Ocurrió un error al enviar la solicitud.', 'error');
        }
      });
      this.main.HideLoading();
      
    }

  }



  async acceptMultiple() {
    console.log("--- ACEPTAR MÚLTIPLES SOLICITUDES ---");
    if (this.selectedSolicitudes.size === 0) {
      console.log("No hay solicitudes seleccionadas.");
      return;
    }

    let updatedData = JSON.parse(JSON.stringify(this.originalPromotionFile));

    const creations: any[] = [];
    const edits: any[] = [];
    const deletions: any[] = [];
    const deletionIndexes: number[] = [];

    this.selectedSolicitudes.forEach(solicitudId => {
      const solicitud = this.dsSolicitudes.data.find((s: any) => s.id === solicitudId);
      if (!solicitud) return;

      switch (solicitud.tipo) { 
        case 1: // Editar: Solo procesar los cambios seleccionados con checkbox
          const selectedAttributes = this.selectedChanges.get(solicitud.id);
          if (selectedAttributes && selectedAttributes.size > 0) {
            const changesToProcess = solicitud.data_solicitud.filter((change: any) => selectedAttributes.has(change.atributo));
            const totalPendingChanges = solicitud.data_solicitud.filter((c: any) => c.estatus === 0).length;
            const finalizada = changesToProcess.length === totalPendingChanges ? 1 : 0;

            if (changesToProcess.length > 0) {
                edits.push({
                  id_solicitud: solicitud.id,
                  codigo: solicitud.codigo,
                  originalIndex: this.getSolicitudOriginalIndex(solicitud),
                  data: changesToProcess,
                  tipo: solicitud.tipo,
                  finalizada: finalizada
                });

                // Aplicar cambios al excel
                const rowIndex = this.findSolicitudRowIndex(updatedData, solicitud);
                if (rowIndex !== -1) {
                  changesToProcess.forEach((change: any) => {
                    updatedData[rowIndex][change.atributo] = change.valor_nuevo;
                  });
                }
            }
          }
          break;
        case 2: // Agregar
          creations.push({
            codigo: solicitud.codigo,
            tipo: solicitud.tipo,
            id_solicitud: solicitud.id
          });

          // Aplicar cambios al excel
          updatedData.push(solicitud.extra_data);
          break;
        case 3: // Eliminar
          deletions.push({
            codigo: solicitud.codigo,
            originalIndex: this.getSolicitudOriginalIndex(solicitud),
            id_solicitud: solicitud.id,
            tipo: solicitud.tipo
          });

          // Aplicar cambios al excel
          const rowIndexToDelete = this.findSolicitudRowIndex(updatedData, solicitud);
          if (rowIndexToDelete !== -1) deletionIndexes.push(rowIndexToDelete);
          break;
      }
    });

    // Eliminar de mayor a menor conserva los originalIndex del archivo base.
    [...new Set(deletionIndexes)]
      .sort((a, b) => b - a)
      .forEach(index => updatedData.splice(index, 1));

    const excelBlob = this.generateExcelBlob(updatedData);

    const payload = { creations, edits, deletions };

    const finalBody = new FormData();
    finalBody.append('id_proj', this.id_camp.toString() as string); 
    finalBody.append('folder', this.folder as string);  
    finalBody.append('payload', JSON.stringify(payload));
    finalBody.append('id_file', this.file_id.toString() as string)
    finalBody.append('blob', excelBlob, `promociones_actualizadas.xlsx`);

 finalBody.forEach((value, key) => {
  console.log(key, value);
});
    console.log("Payload Masivo a Aceptar (FormData):", finalBody);

   const result = await Swal.fire({
      title: '¿Aceptar solicitudes?',
      text: "Se efectuarán las solicitudes seleccionadas.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar'
    });
  if (result.isConfirmed) {
      this.main.ShowLoading();
          this.projectsS.acceptSoliPromociones(finalBody).subscribe({
        next: (x: any) => {
          if (x.message == "Success") {
                       Swal.fire({
                         icon: 'success',
                         title: 'Promociones editadas',
                         text: 'Promociones editadas exitosamente'          
                       }).then(() => {            
                         this.selectedSolicitudes.clear();
                         this.selectedChanges.clear();
                         this.getPromoFile(); 
                       });  
          } else {
            Swal.fire('Error', 'Ocurrió un error al editar el archivo.', 'error');
          }
          this.main.HideLoading();
        },
        error: (err: any) => {
          this.main.HideLoading();
          console.error(err);
          Swal.fire('Error', 'Ocurrió un error al editar el archivo, por favor vuelve a intentarlo.', 'error');
        }
      });
    }

  }

  async rejectMultiple() {
    console.log("--- RECHAZAR MÚLTIPLES SOLICITUDES ---");
    if (this.selectedSolicitudes.size === 0) { 
      console.log("No hay solicitudes seleccionadas.");
      return;
    }

    const creations: any[] = [];
    const edits: any[] = [];
    const deletions: any[] = [];

    this.selectedSolicitudes.forEach(solicitudId => {
      const solicitud = this.dsSolicitudes.data.find((s: any) => s.id === solicitudId);
      if (!solicitud) return;

      switch (solicitud.tipo) {
        case 1: // Editar: Solo procesar los cambios seleccionados con checkbox
          const selectedAttributes = this.selectedChanges.get(solicitud.id);
          if (selectedAttributes && selectedAttributes.size > 0) {
            const changesToReject = solicitud.data_solicitud.filter((change: any) => selectedAttributes.has(change.atributo));
            const totalPendingChanges = solicitud.data_solicitud.filter((c: any) => c.estatus === 0).length;
            const finalizada = changesToReject.length === totalPendingChanges ? 1 : 0;

            if (changesToReject.length > 0) {
                edits.push({
                  id_solicitud: solicitud.id,
                  codigo: solicitud.codigo,
                  data: changesToReject,
                  tipo: solicitud.tipo,
                  finalizada: finalizada,
                  has_accepted_change: solicitud.has_accepted_change
                });
            }
          }
          break;
        case 2: // Agregar
        case 3: // Eliminar
          // Para 'agregar' y 'eliminar', el rechazo es sobre la solicitud completa.
          const payloadItem = {
            id_solicitud: solicitud.id,
            codigo: solicitud.codigo,
            tipo: solicitud.tipo
          };
          solicitud.tipo === 2 ? creations.push(payloadItem) : deletions.push(payloadItem);
          break;
      }
    });

    const payload = { creations, edits, deletions };    
    const finalBody = {
      id_proj: this.id_camp,
      folder: this.folder,
      payload: payload,
      id_file : this.file_id
    };

    console.log("Payload Masivo a Rechazar (JSON):", finalBody);

   const result = await Swal.fire({
      title: '¿Denegar solicitud?',
      text: "Se denegarán las solicitudes de edición.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí',
      cancelButtonText: 'Cancelar'
    });
 if (result.isConfirmed) {
    this.main.ShowLoading();
      this.projectsS.rejectSoliPromociones(finalBody).subscribe(async (res: any) => {
        this.main.HideLoading();
        if (res.message === "Success") {
                       Swal.fire({
                         icon: 'success',
                         title: 'Proceso completado',
                         text: 'Proceso efectuado exitosamente'          
                       }).then(() => {            
                         this.selectedSolicitudes.clear();
                         this.selectedChanges.clear();
                         this.getPromoFile(); 
                       }); 

        }else{
          Swal.fire('Error', 'Ocurrió un error al enviar la solicitud.', 'error');
        }
      });
      this.main.HideLoading();
    }
    
  }

  selectStatus(status: number) {
   
    if (this.statusSelected > 0 && status > 0) {
      this.tabGroup.selectedIndex = 0;
    }

    this.selectedChanges.clear();
    this.selectedSolicitudes.clear();

    this.solicitudesFilterValue = '';

    if (this.hasChanges) {
      this.revertChanges(true); 
    }

    this.statusSelected = status;
    console.log("Status seleccionado:", this.statusSelected);


    setTimeout(() => {
      if (status === 0) {
        this.tabGroup.selectedIndex = 0; // Pestaña Principal
        this.dsSolicitudes.filter = ''; // Limpiar filtro de solicitudes
      } else {
        this.tabGroup.selectedIndex = 1; // Pestaña Solicitudes

        this.applySolicitudesFilter();

        if (this.dsSolicitudes.paginator) {
          this.dsSolicitudes.paginator.firstPage();
        }
      }
    }, 0);
  }

  applySolicitudesFilter(event?: Event) {
    if (event) {
      this.solicitudesFilterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    }
    // Usamos un valor aleatorio para forzar la re-evaluación del filterPredicate
    this.dsSolicitudes.filter = Math.random().toString();
  }


  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dspromotionFile.filter = filterValue.trim().toLowerCase();
    if (this.dspromotionFile.paginator) this.dspromotionFile.paginator.firstPage();
  }

  getCellType(value: any): string {
    if (value instanceof Date || /^\d{4}-\d{2}-\d{2}$/.test(value)){
      return 'date';
    } 
    if (typeof value === 'number'){
       return 'number';
    }
    return 'text';
  }

  openUploadPromotions(){
    this.main.ShowLoading();
        this.projectsS.getProjects(this.id_camp).subscribe((x: any) => {
          this.main.HideLoading();
          let campaignsData = x.data;
            this.main.ShowLoading();
              this.matDialog.open(ProjectsPromotionsAddComponent, {
                panelClass: ['dialogs-md'],
                data: {
                  project: campaignsData.project,
                  id_camp : this.id_camp
                }
              }).afterClosed().subscribe(
                resp => {
                 this.getPromoFile();
                }
              );
        });
  }

  openHistory(){
     this.main.ShowLoading();
       this.matDialog.open(ProjectsPromotionsLogsComponent, {
         panelClass: ['dialogs-md'],
         data: {
           id_file: this.file_id,
           id_solicitud : 0
         }
       }).afterClosed().subscribe(
         resp => {
          this.getPromoFile();
         }
       );
  }

   openConfig(){
     this.main.ShowLoading();
       this.matDialog.open(PromotionsConfigurationComponent, {
         panelClass: ['dialogs-md'],
         data: {
           id_file: this.file_id,
           id_proj : this.id_camp
         }
       }).afterClosed().subscribe(
         resp => {
          this.getPromoFile();
         }
       );
    }


  openHistoryByCamp(id_proj : number, id_solicitud : any, codigo : any){
     this.main.ShowLoading();
       this.matDialog.open(ProjectsPromotionsLogsComponent, {
         panelClass: ['dialogs-md'],
         data: {
          id_proj : id_proj,
          id_solicitud : id_solicitud,
          codigo : codigo
         }
       }).afterClosed().subscribe(
         resp => {
          
         }
       );
  }

  downloadChangeHistory(): void {
    if (this.isDownloadingHistory) return;

    this.isDownloadingHistory = true;
    this.main.ShowLoading();
    this.projectsS.getPromoChangelogByCamp({
      id_proj: this.id_camp,
      id_solicitud: null,
      codigo: null
    }).subscribe(
      async (result: any) => {
        const logs = Array.isArray(result?.data) ? result.data : [];

        if (logs.length === 0) {
          this.finishHistoryDownload();
          await Swal.fire('Sin historial', 'No hay cambios registrados para descargar.', 'info');
          return;
        }

        const history = [...logs].sort((a: any, b: any) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime())
      .map((log: any) => ({
            'Fecha': this.datePipe.transform(log.created_at, 'dd/MM/yyyy hh:mm a', '-0000') || '', // formateo para que no quede la fecha "rara"
            'Detalle': log.content || '',
            'Nombre usuario': log.name || '',
            'Rol': this.getHistoryUserRole(log)
          }));

        try {
          await this.main.generateExcel(  history,  `Historial_promociones_${this.id_camp}`,  'Historial de cambios',`Historial de cambios de promociones - Proyecto ${this.id_camp}`
          );
        } catch (error) {
          await Swal.fire('Error al generar Excel', 'No fue posible generar el archivo del historial.', 'error');
        } finally {
          this.finishHistoryDownload();
        }
      },
     async () => {
        this.finishHistoryDownload();
     await Swal.fire('Error al obtener historial', 'No fue posible obtener el historial de cambios.', 'error');
      }
    );
  }

  private getHistoryUserRole(log: any): string {
    return log.id_rol === 3 && log.company_name ? log.company_name : (log.rol || '');
  }

  private finishHistoryDownload(): void {
    this.isDownloadingHistory = false;
    this.main.HideLoading();
  }

  
  async addRow() {
    const { value: codigosInput } = await Swal.fire({
      title: "Agregar nueva(s) promoción(es)",
      input: 'text',
      inputLabel: "CÓDIGO(S) PRINCIPAL(ES)",
      inputPlaceholder: "Ingrese un código o una lista de códigos",
      showCancelButton: true,
      confirmButtonText: "Agregar",
      cancelButtonText: "Cancelar",
      inputValidator: (value: string) => {
        if (!value) {
          return "Necesitas ingresar al menos un CÓDIGO PRINCIPAL";
        }
        return null;
      }
    });

    if (codigosInput) {
      const codigos = codigosInput.split(',').map((c: string) => c.trim()).filter((c: string) => c);
      const uniqueCodigos = [...new Set(codigos)];

      const existingCodigos = new Set(this.dspromotionFile.data.map((row: any) => row['CODIGO PRINCIPAL']));
      const newUniqueCodigos = uniqueCodigos.filter(codigo => !existingCodigos.has(codigo));

      if (newUniqueCodigos.length === 0) {
        Swal.fire('Atención', 'Todos los códigos proporcionados ya existen en la tabla.', 'warning');
        return;
      }

      const newRows = newUniqueCodigos.map(codigo => {
        const newRow: any = { "CODIGO PRINCIPAL": codigo };
        this.displayedColumns.forEach(col => {
          if (col !== "CODIGO PRINCIPAL") newRow[col] = null;
        });
        newRow.status = 'created';
        this.createdRows.add(newRow);
        return newRow;
      });

      this.dspromotionFile.data = [...newRows, ...this.dspromotionFile.data];
      this.dspromotionFile._updateChangeSubscription();
      this.hasChanges = true;
      this.updateCountCambios();

      if (newUniqueCodigos.length < uniqueCodigos.length) {
        const duplicateCount = uniqueCodigos.length - newUniqueCodigos.length;
        Swal.fire('Éxito', `Promociones agregadas. ${duplicateCount} código(s) ya existían y fueron omitidos.`, 'info');
      } else {
        Swal.fire('Éxito', `Promociones agregadas correctamente.`, 'success');
      }

      if (newRows.length === 1) {
        this.startEditing(newRows[0]);
      }
    }
  }

  addRowsFromList() {
    if (!this.codigosList || this.codigosList.trim() === '') {
      Swal.fire("Lista vacía", "Por favor ingrese una lista de códigos.", 'info');
      return;
    }

    const codigos = this.codigosList.split(',').map(c => c.trim()).filter(c => c !== '');

    if (codigos.length === 0) {
      Swal.fire("Lista vacía", "No se encontraron códigos válidos en la lista.", 'info');
      return;
    }

    const newRows = codigos.map(codigoPrincipal => {
      const newRow: any = { "CODIGO PRINCIPAL": codigoPrincipal };
      this.displayedColumns.forEach(col => {
        if (col !== "CODIGO PRINCIPAL") {
          newRow[col] = null;
        }
      });
      return newRow;
    });

    this.dspromotionFile.data = [...newRows, ...this.dspromotionFile.data];
    this.hasChanges = true;
    this.codigosList = ''; 
    Swal.fire('Filas agregadas', `${newRows.length} fila(s) ha(n) sido agregada(s)`, 'success');
  }

  revertChanges(silent = false) {
    if(!silent){
       Swal.fire({
      title: '¿Revertir cambios?',
      text: "Perderá todas las modificaciones no guardadas. ¿Desea continuar?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: "Sí, revertir",
      cancelButtonText: 'Cancelar',
      showConfirmButton: !silent,
    }).then((result) => {
      if (result.isConfirmed) {
        this.dspromotionFile.data = JSON.parse(JSON.stringify(this.originalPromotionFile));
        this.dspromotionFile.data.forEach((row:any, index: number) => { row.status = 'normal'; row.originalIndex = index; });
        this.dspromotionFile._updateChangeSubscription();
        this.editingRow = null;
        this.editedRows.clear();
        this.createdRows.clear();
        this.deletedRows.clear();
        this.hasChanges = false;
        this.updateCountCambios();
        if (!silent) {
          Swal.fire('Revertido', 'Los cambios han sido descartados.', 'success');
        }
      }
    });
  }else{
        this.dspromotionFile.data = JSON.parse(JSON.stringify(this.originalPromotionFile));
        this.dspromotionFile.data.forEach((row:any, index: number) => { row.status = 'normal'; row.originalIndex = index; });
        this.dspromotionFile._updateChangeSubscription();
        this.editingRow = null;
        this.editedRows.clear();
        this.createdRows.clear();
        this.deletedRows.clear();
        this.hasChanges = false;
        this.updateCountCambios();
  }
    }


  downloadTemplate() {
    this.main.generateExcel([], 'Plantilla_Promociones', 'Plantilla', "", this.displayedColumns);
  }

  downloadExcel() {
    this.main.generateExcel(this.originalPromotionFile, 'Plantilla_Promociones', 'Plantilla', "", this.displayedColumns);
  }
  

  onFileSelectedNewPromotions(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const headers: string[] = (XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] as string[])?.map(h => h.trim()) || [];

      if (!headers.includes('CODIGO PRINCIPAL')) {
        Swal.fire('Error de formato', 'El archivo subido debe contener la columna "CODIGO PRINCIPAL".', 'error');
        return;
      }

      const uploadedData: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      const existingCodigos = new Set(this.dspromotionFile.data.map((row: any) => row['CODIGO PRINCIPAL']));
      let newRowsCount = 0;

      uploadedData.forEach(uploadedRow => {
        const codigoPrincipal = uploadedRow['CODIGO PRINCIPAL'];
        // if (codigoPrincipal && !existingCodigos.has(codigoPrincipal)) { // Se comenta para permitir duplicados temporalmente
        if (codigoPrincipal) {
          const newRow: any = { "CODIGO PRINCIPAL": codigoPrincipal, status: 'created' };
          this.displayedColumns.forEach(col => {
            if (col !== "CODIGO PRINCIPAL") {
              newRow[col] = uploadedRow.hasOwnProperty(col) ? uploadedRow[col] : null;
            }
          });
          this.dspromotionFile.data.unshift(newRow);
          this.createdRows.add(newRow);
          existingCodigos.add(codigoPrincipal); // Add to set to avoid duplicates from same file
          newRowsCount++;
        }
      });

      if (newRowsCount > 0) {
        this.dspromotionFile._updateChangeSubscription();
        this.hasChanges = true;
        this.updateCountCambios();
        Swal.fire('Carga completada', `${newRowsCount} nuevas promociones agregadas.`, 'success');
      } else {
        Swal.fire('Sin cambios', 'No se encontraron promociones nuevas para agregar.', 'info');
      }
    };

    reader.readAsBinaryString(file);
    event.target.value = null; // Reset file input
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    if (this.promotionFile.length === 0) {
      Swal.fire('Tabla vacía', 'No se pueden cargar promociones porque la tabla está vacía.', 'warning');
      event.target.value = null;
      return;
    }

    this.onFileSelectedNewPromotions(event);
  }

  onFileSelectedOld(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const headers: string[] = (XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] as string[]) || [];

      if (!headers.includes('CODIGO PRINCIPAL')) {
        Swal.fire('Error de formato', 'El archivo subido debe contener la columna "CODIGO PRINCIPAL".', 'error');
        return;
      }

      const uploadedData: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      const newRows = uploadedData.map(uploadedRow => {
        const newRow: any = {};
        this.displayedColumns.forEach(col => {
          if (uploadedRow.hasOwnProperty(col)) {
            let value = uploadedRow[col];
            if (value instanceof Date) {
              newRow[col] = this.datePipe.transform(value, 'yyyy-MM-dd');
            } else {
              newRow[col] = value;
            }
          } else {
            newRow[col] = null;
          }
        });
        return newRow;
      });

      this.dspromotionFile.data = [...newRows, ...this.dspromotionFile.data];
      this.hasChanges = true;
      Swal.fire('Filas agregadas', `${newRows.length} fila(s) ha(n) sido agregada(s).`, 'success');
    };

    reader.readAsBinaryString(file);
    event.target.value = null; 
  }

  startEditing(row: any) {
    if (row.status === 'deleted' ) {
      return; 
    }

   
    if (this.editingRow && this.editingRow !== row) {
      this.revertRowChanges(this.editingRow);
    }

    this.editingRow = row;
    this.originalRowData = JSON.parse(JSON.stringify(row));
    row.status = 'editing';
  }

  private canApplyPromotionDirectly(row: any): boolean {
    if (this.userService.getUser().id_rol === 1 || this.hasPermissions('super_promo', null, true)) {
      return true;
    }

    const responsable = String(row?.RESPONSABLE_PROMOCION ?? '').trim();
    const currentUserEmail = String(this.userService.getUser().email ?? '').trim().toLowerCase();

    return responsable.toUpperCase() === 'ABIERTA'
      || (responsable.includes('@') && responsable.toLowerCase() === currentUserEmail);
  }

  private updateCountCambios(): void {
    const edited = Array.from(this.editedRows.values()).map(edit =>
      this.dspromotionFile.data.find((row: any) => row.originalIndex === edit.originalIndex)
      ?? { RESPONSABLE_PROMOCION: edit.responsable_promocion }
    );
    const operations = [
      ...Array.from(this.createdRows),
      ...edited,
      ...Array.from(this.deletedRows.values()).map(deleted => deleted.data)
    ];

    this.sumSinResponsable = operations.filter(row => this.canApplyPromotionDirectly(row)).length;
    this.sumResponsable = operations.length - this.sumSinResponsable;
  }

 acceptRowChanges(row: any) {
    if (this.createdRows.has(row)) {
      row.status = 'created';
    } else {
      row.status = 'edited';
      const changes: any = {};
   
      const allKeys = new Set([...Object.keys(row), ...Object.keys(this.originalRowData)]);

      allKeys.forEach(key => {
        if (key === 'status' || key === 'originalIndex') {
          return; 
        }

        const originalValue = this.originalRowData[key] || '-';
        const currentValue = row[key] || '-';

        if (currentValue !== originalValue) {
          changes[key] = { original: originalValue, nuevo: currentValue };
        }
      });
      this.editedRows.set(row.originalIndex, { 
        originalIndex: row.originalIndex, 
        codigo: row['CODIGO PRINCIPAL'], 
        changes: changes, 
        responsable_promocion: row.RESPONSABLE_PROMOCION });
    }
    this.editingRow = null;
    this.originalRowData = null;
    this.hasChanges = true;
    this.updateCountCambios();
    this.cdr.detectChanges();
  }

  revertRowChanges(row: any) {
    const rowIndex = this.dspromotionFile.data.findIndex((r:any) => r === row);
    if (rowIndex === -1) return;

    if (row.status === 'editing') {
 
      Object.assign(this.dspromotionFile.data[rowIndex], this.originalRowData);
      if (this.createdRows.has(row)) {
        this.dspromotionFile.data[rowIndex].status = 'created';
      } else {
        this.dspromotionFile.data[rowIndex].status = this.editedRows.has(row.originalIndex) ? 'edited' : 'normal';
      }

    } else if (row.status === 'edited') {
    
      const originalData = this.originalPromotionFile[row.originalIndex];
      Object.assign(this.dspromotionFile.data[rowIndex], originalData);
      this.dspromotionFile.data[rowIndex].status = 'normal'; 
      
      this.editedRows.delete(row.originalIndex); 
    } else if (row.status === 'deleted') {
 
      row.status = 'normal';
      this.deletedRows.delete(row.originalIndex);
    }

   if (this.editingRow === row) {
      this.editingRow = null;
      this.originalRowData = null;
    }

    this.hasChanges = this.createdRows.size > 0 || this.editedRows.size > 0 || this.deletedRows.size > 0;
    this.updateCountCambios();
    this.dspromotionFile._updateChangeSubscription();
    this.cdr.detectChanges();
  }

   deleteRow(row: any) {
    const codigo = row['CODIGO PRINCIPAL'] || 'sin código';
    Swal.fire({
      title: '¿Está seguro?',
      html: `¿Desea eliminar esta fila con <b>CODIGO PRINCIPAL: ${codigo}</b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        
        if (row.status === 'created' || (row.status === 'editing' && this.createdRows.has(row))) {
          this.createdRows.delete(row);
          const rowIndex = this.dspromotionFile.data.findIndex((r:any) => r === row);
          if (rowIndex === -1) return;
          this.dspromotionFile.data.splice(rowIndex, 1);
          this.dspromotionFile._updateChangeSubscription();
          this.hasChanges = this.createdRows.size > 0 || this.editedRows.size > 0 || this.deletedRows.size > 0;
          this.updateCountCambios();
          return;
        }
        
        if (row.status === 'editing' || row.status === 'edited') {
          this.revertRowChanges(row);
        }
        
        row.status = 'deleted';
        this.deletedRows.set(row.originalIndex, 
          { originalIndex: row.originalIndex,
           codigo: row['CODIGO PRINCIPAL'], 
           data : row });
        this.hasChanges = true;
        this.updateCountCambios();
        this.cdr.detectChanges();
      }
    });
  }

  isRowEditing(row: any): boolean {
    return this.editingRow === row;
  }

  isColumnEditable(column: string): boolean {
    return column !== 'CODIGO PRINCIPAL' && this.editableColumns.has(column);
  }

  getRowClass(row: any): string {
    switch (row.status) {
      case 'editing': return 'row-editing';
      case 'created': return 'row-created';
      case 'edited': return 'row-edited';
      case 'deleted': return 'row-deleted';
      default: return '';
    }
  }

  getSolicitudRowClass(solicitud: any): string {

    switch (solicitud.tipo) {
      case 1: return 'row-edited2'; // Editado (Naranja)
      case 2: return 'row-created'; // Creado (Verde)
      case 3: return 'row-deleted'; // Eliminado (Gris y tachado)
      default: return '';
    }
  }

  getChange(solicitud: any, columnName: string): any | null {
    if (solicitud.tipo !== 1 || !solicitud.data_solicitud) {
      return null;
    }
    return solicitud.data_solicitud.find((change: any) => change.atributo === columnName);
  }

  aceptarSolicitud(solicitud: any) {
    console.log("Aceptar", solicitud);
  }

  rechazarSolicitud(solicitud: any) {
    console.log("Rechazar", solicitud);
  }

  async sendSolicitud(){
   
    const creados = [...this.createdRows];
    const editados = Array.from(this.editedRows.values());
    const eliminados = Array.from(this.deletedRows.values());

    const payload = {
      id_proyecto : this.id_camp,
      id_usuario : 0,
      id_archivo : this.file_id,
      creados,
      editados,
      eliminados
    };

    console.log("--- Payload para la solicitud ---", payload);

    const result = await Swal.fire({
      title: '¿Enviar solicitud?',
      text: "Se enviará la solicitud de edición.",
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, enviar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      this.main.ShowLoading();
      this.projectsS.createSolicitudes(payload).subscribe(async (res: any) => {
        this.main.HideLoading();
        if (res.message === "Success") {
                       Swal.fire({
                         icon: 'success',
                         title: 'Solicitud enviada',
                         text: 'Proceso efectuado exitosamente'          
                       }).then(() => {            
                         this.getPromoFile();
                         this.createdRows.clear();
                         this.editedRows.clear();
                         this.deletedRows.clear();
                       }); 

        }else{
          Swal.fire('Error', 'Ocurrió un error al enviar la solicitud.', 'error');
        }
      });
      this.main.HideLoading();
    }

  }

  async saveChanges(){

    this.updateCountCambios();
    let titleSwal = '';
    let messageSwal = '';
    let titleSuccess = '';
    let messageSuccess = '';

    if(this.sumResponsable>0 && this.sumSinResponsable == 0){
      titleSwal = "¿Enviar solicitud?";
      messageSwal = "Se enviará la solicitud de edición";
      titleSuccess = "Solicitud enviada"
      messageSuccess = "Proceso efectuado exitosamente";
    }
    else if(this.sumResponsable>0 && this.sumSinResponsable>0){
      titleSwal = "¿Guardar cambios?";
      messageSwal = "Se guardarán las modificaciones y se harán las solicitudes correspondientes";
      titleSuccess = "Archivo guardado"
      messageSuccess = "Las promociones han sido guardadas exitosamente.";
    }
    else{
      titleSwal = "¿Guardar cambios?";
      messageSwal = "Se guardarán las modificaciones correspondientes";
      titleSuccess = "Archivo guardado"
      messageSuccess = "Las promociones han sido guardadas exitosamente.";
    }

    const result = await Swal.fire({
      title: titleSwal,
      text: messageSwal,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Sí, guardar',
      cancelButtonText: 'Cancelar'
    });

    if (result.isConfirmed) {
      this.main.ShowLoading();
      const creados = [...this.createdRows];
      const editados = Array.from(this.editedRows.values());
      const eliminados = Array.from(this.deletedRows.values());

      const payload = {
        id_proyecto : this.id_camp,
        id_usuario : 0,
        id_archivo : this.file_id,
        creados,
        editados,
        eliminados
      };

     console.log("--- Payload para la solicitud ---", payload);

      const originalMap = new Map(this.originalData.map( (r:any) => [r.originalIndex, r]));

      const finalData = this.dspromotionFile.data
        .filter((row: any) => {
          if (this.createdRows.has(row)) return this.canApplyPromotionDirectly(row);
          if (row.status === 'deleted') return !this.canApplyPromotionDirectly(row);
          return true;
        })
        .map((row:any) => {
          if ((row.status === 'edited' || row.status === 'deleted') && !this.canApplyPromotionDirectly(row)) {
            return originalMap.get(row.originalIndex) || row;
          }
          return row;
        });

      const dataToSave = finalData
        .map((row:any) => {
     
        const newRow: any = {};
        this.displayedColumns.forEach(col => {
          newRow[col] = row[col] ?? ''; 
        });
        return newRow;
      });

      const newWorksheet = XLSX.utils.json_to_sheet(dataToSave);
      const newWorkbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, 'Promociones');

      const newWorkbookBuffer = XLSX.write(newWorkbook, { bookType: 'xlsx', type: 'array' });
      const blob = new Blob([newWorkbookBuffer], { type: 'application/octet-stream' });
      this.bodyForm.append('id_proj', this.id_camp.toString() as string);
      this.bodyForm.append('id_file', this.file_id.toString() as string);
      this.bodyForm.append('blob', blob, this.fileName);
      this.bodyForm.append('payload', JSON.stringify(payload));
      this.projectsS.editSheetPromociones(this.bodyForm).subscribe({
        next: (x: any) => {
          this.main.HideLoading();
          if (x.message == "Success") {
                       Swal.fire({
                         icon: 'success',
                         title: titleSuccess,
                         text: messageSuccess
                       }).then(() => {            
                         this.getPromoFile();
                         this.sumResponsable = 0;
                         this.sumSinResponsable = 0;
                       });  
          } else {
            Swal.fire('Error', 'Ocurrió un error al editar el archivo.', 'error');
          }
        },
        error: (err: any) => {
          this.main.HideLoading();
          console.error(err);
          Swal.fire('Error', 'Ocurrió un error al editar el archivo, por favor vuelve a intentarlo.', 'error');
        }
      });
    }
  }

    deleteRowOld(rowIndex: number, row: any) {
    const codigo = row['CODIGO PRINCIPAL'] || 'sin código';
    Swal.fire({
      title: '¿Está seguro?',
      html: `¿Desea eliminar esta fila con <b>CODIGO PRINCIPAL: ${codigo}</b>?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        const data = this.dspromotionFile.data;
        data.splice(rowIndex, 1);
        this.dspromotionFile.data = data;
        this.hasChanges = true;
      }
    });
  }

    onFileSelected_prev(event: any) {
    const file = event.target.files[0];
    if (!file) {
      return;
    }

    if (this.promotionFile.length === 0) {
      Swal.fire('Tabla vacía', 'No se pueden cargar promociones porque la tabla está vacía.', 'warning');
      event.target.value = null;
      return;
    }

    const reader = new FileReader();
    reader.onload = (e: any) => {
      const workbook = XLSX.read(e.target.result, { type: 'binary', cellDates: true });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      const headers: string[] = (XLSX.utils.sheet_to_json(worksheet, { header: 1 })[0] as string[])?.map(h => h.trim()) || [];

      if (!headers.includes('CODIGO PRINCIPAL')) {
        Swal.fire('Error de formato', 'El archivo subido debe contener la columna "CODIGO PRINCIPAL".', 'error');
        return;
      }

      const uploadedData: any[] = XLSX.utils.sheet_to_json(worksheet, { raw: true });

      const validColumns = headers.filter(h => this.displayedColumns.includes(h));

      let newRowsCount = 0;
      let editedRowsCount = 0;

      uploadedData.forEach(uploadedRow => {
        const codigoPrincipal = uploadedRow['CODIGO PRINCIPAL'];
        const existingRowIndex = this.dspromotionFile.data.findIndex((r: any) => r['CODIGO PRINCIPAL'] === codigoPrincipal);

        if (existingRowIndex !== -1) { // Fila existente, buscar cambios
          const existingRow = this.dspromotionFile.data[existingRowIndex];
          const originalRow = this.originalPromotionFile[existingRow.originalIndex];
          let changesDetected = false;
          const changes: any = {};

          validColumns.forEach(col => {
            if (uploadedRow.hasOwnProperty(col) && existingRow[col] !== uploadedRow[col]) {
              changes[col] = { original: originalRow[col] || '-', nuevo: uploadedRow[col] };
              existingRow[col] = uploadedRow[col];
              changesDetected = true;
            }
          });

          if (changesDetected) {
            existingRow.status = 'edited';
            this.editedRows.set(existingRow.originalIndex,
               { originalIndex: existingRow.originalIndex, codigo: codigoPrincipal,
                 changes: changes,
                  responsable_promocion: existingRow.RESPONSABLE_PROMOCION });
            editedRowsCount++;
          }
        } else { // Fila nueva
          const newRow: any = { "CODIGO PRINCIPAL": codigoPrincipal, status: 'created' };
          this.displayedColumns.forEach(col => {
            if (col !== "CODIGO PRINCIPAL") {
              newRow[col] = uploadedRow.hasOwnProperty(col) ? uploadedRow[col] : null;
            }
          });
          this.dspromotionFile.data.unshift(newRow);
          this.createdRows.add(newRow);
          newRowsCount++;
        }
      });

      this.dspromotionFile._updateChangeSubscription();
      this.hasChanges = true;
      Swal.fire('Carga completada', `${newRowsCount} promociones nuevas y ${editedRowsCount} promociones editadas.`, 'success');
    };

    reader.readAsBinaryString(file);
    event.target.value = null;
  }

}
